












































import { Component, Prop, Vue } from "vue-property-decorator";
import CheckboxCommon from "@/components/lib/CheckboxCommon.vue";
import InputSelect from "@/components/lib/InputSelect.vue";
import {
  ContactWayOption,
  IContactWayOption,
  IContactWayOptionData,
  IOption,
} from "@/components/lib/models";
import { Theme } from "@/store";

@Component({
  components: {
    CheckboxCommon,
    InputSelect,
  },
})
export default class ContactWayPicker extends Vue {
  @Prop() readonly value!: IContactWayOption[];
  @Prop() readonly theme?: Theme;
  @Prop({ default: false }) readonly selectColor?: boolean;

  private messengerType: string = "messenger";

  get commonContactWays(): IContactWayOption[] {
    return this.value.filter(
      (way: IContactWayOption) => way.type !== this.messengerType
    );
  }

  get messengerChoice(): boolean {
    return !!this.messengers?.filter((way: IContactWayOption) => way.value)
      .length;
  }
  set messengerChoice(value: boolean) {
    if (value) {
      if (!this.currentMessengerId && this.messengerOptions.length) {
        this.currentMessengerId = this.messengerOptions[0].value;
      }
    } else {
      this.currentMessengerId = undefined;
    }
  }

  get messengers(): IContactWayOption[] {
    return this.value.filter(
      (way: IContactWayOption) => way.type === this.messengerType
    );
  }

  get messengerOptions(): IOption<number>[] {
    return this.messengers.map((way: IContactWayOption) => ({
      name: way.name,
      value: way.id,
    }));
  }

  get currentMessengerId(): number | undefined {
    return this.messengers?.find((way: IContactWayOption) => way.value)?.id;
  }
  set currentMessengerId(value: number | undefined) {
    let updatedMessengers: IContactWayOption[] = [];
    if (this.currentMessengerId) {
      let oldMessenger = this.messengers.find(
        (way: IContactWayOption) => way.id === this.currentMessengerId
      );
      if (oldMessenger) {
        updatedMessengers.push({
          ...oldMessenger,
          value: false,
        });
      }
    }
    if (value) {
      let newMessenger = this.messengers.find(
        (way: IContactWayOption) => way.id === value
      );
      if (newMessenger) {
        updatedMessengers.push({
          ...newMessenger,
          value: true,
        });
      }
    }
    this.$emit(
      "input",
      updatedMessengers.map(
        (item: IContactWayOptionData) => new ContactWayOption(item)
      )
    );
  }
}
